import { login, getInfo, logout } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {},
  roles: [],
  permissions: [],
  menus: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  SET_MENUS(state, menus) {
    state.menus = menus
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return login({ username, password }).then(res => {
      const { token } = res.data
      commit('SET_TOKEN', token)
      setToken(token)
    })
  },

  getInfo({ commit }) {
    return getInfo().then(res => {
      const { userInfo, roles, permissions, menus } = res.data
      commit('SET_USER_INFO', userInfo)
      commit('SET_ROLES', roles)
      commit('SET_PERMISSIONS', permissions)
      commit('SET_MENUS', menus)
      return res.data
    })
  },

  logout({ commit }) {
    return logout().finally(() => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      commit('SET_MENUS', [])
      removeToken()
    })
  },

  resetToken({ commit }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', {})
    commit('SET_ROLES', [])
    commit('SET_PERMISSIONS', [])
    commit('SET_MENUS', [])
    removeToken()
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
